(function () {
  'use strict';

  var STORAGE_KEY = 'wanderth_wishlist';
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function setList(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wanderth:wishlist:change', { detail: { list: arr } }));
  }

  function toggleHandle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    setList(list);
    return idx === -1;
  }

  function removeHandle(handle) {
    var list = getList().filter(function (h) { return h !== handle; });
    setList(list);
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
  }

  function syncButtons() {
    var list = getList();
    var buttons = document.querySelectorAll('.wanderth-wishlist-toggle');
    buttons.forEach(function (btn) {
      var h = btn.getAttribute('data-product-handle');
      var active = list.indexOf(h) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Añadir a favoritos');
    });

    var countEls = document.querySelectorAll('[data-wishlist-count]');
    countEls.forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-visible', list.length > 0);
    });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function renderDrawerContent() {
    var container = document.querySelector('[data-wishlist-items]');
    var emptyEl = document.querySelector('[data-wishlist-empty]');
    if (!container) return;

    var list = getList();
    if (list.length === 0) {
      container.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';

    container.innerHTML = '<div class="wanderth-wishlist__loading">Cargando…</div>';

    Promise.all(list.map(fetchProduct)).then(function (results) {
      var items = results.filter(Boolean);
      if (items.length === 0) {
        container.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }

      container.innerHTML = items.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var price = formatMoney(p.price);
        var compare = (p.compare_at_price && p.compare_at_price > p.price)
          ? '<span class="wanderth-wishlist__compare">' + formatMoney(p.compare_at_price) + '</span>'
          : '';
        return ''
          + '<div class="wanderth-wishlist__item" data-handle="' + p.handle + '">'
          +   '<a href="' + p.url + '" class="wanderth-wishlist__image-link">'
          +     (img ? '<img src="' + img + '" alt="" loading="lazy">' : '')
          +   '</a>'
          +   '<div class="wanderth-wishlist__info">'
          +     '<a href="' + p.url + '" class="wanderth-wishlist__title">' + p.title + '</a>'
          +     '<div class="wanderth-wishlist__price">' + price + ' ' + compare + '</div>'
          +     '<button type="button" class="wanderth-wishlist__remove" data-handle="' + p.handle + '" aria-label="Quitar ' + p.title + ' de favoritos">Quitar</button>'
          +   '</div>'
          + '</div>';
      }).join('');
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    // Visible para teclado/lectores: quitar aria-hidden e inert al abrir.
    drawer.removeAttribute('aria-hidden');
    drawer.removeAttribute('inert');
    document.body.classList.add('js-drawer-open-wishlist');
    renderDrawerContent();
  }

  function closeDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    // Oculto de nuevo: inert evita que el botón cerrar quede enfocable estando oculto.
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('js-drawer-open-wishlist');
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest && e.target.closest('.wanderth-wishlist-toggle');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var h = toggleBtn.getAttribute('data-product-handle');
      if (h) toggleHandle(h);
      syncButtons();
      return;
    }

    if (e.target.closest && e.target.closest('.js-wishlist-open')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest && (e.target.closest('.js-wishlist-close') || e.target.closest('.wanderth-wishlist-overlay'))) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest && e.target.closest('.wanderth-wishlist__remove');
    if (removeBtn) {
      e.preventDefault();
      var rh = removeBtn.getAttribute('data-handle');
      if (rh) removeHandle(rh);
      syncButtons();
      renderDrawerContent();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('wanderth:wishlist:change', syncButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
})();
